import { render, staticRenderFns } from "./OrganLivers.vue?vue&type=template&id=a53298b6&"
var script = {}
import style0 from "./OrganLivers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports